export default __webpack_public_path__ + "static/media/lokkalamandal.3b71edd0.jpg";